// source: projects/erp/service/api/v1/model/email_message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.qowner.erp.api.v1.model.EmailMessage', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.qowner.erp.api.v1.model.EmailMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.qowner.erp.api.v1.model.EmailMessage.repeatedFields_, null);
};
goog.inherits(proto.qowner.erp.api.v1.model.EmailMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.qowner.erp.api.v1.model.EmailMessage.displayName = 'proto.qowner.erp.api.v1.model.EmailMessage';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.qowner.erp.api.v1.model.EmailMessage.repeatedFields_ = [8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.qowner.erp.api.v1.model.EmailMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.qowner.erp.api.v1.model.EmailMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.qowner.erp.api.v1.model.EmailMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, 0),
    date: (f = msg.getDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    externalId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    parentId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    subject: jspb.Message.getFieldWithDefault(msg, 6, ""),
    sender: jspb.Message.getFieldWithDefault(msg, 7, ""),
    recipientsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    copiesList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    bodyText: jspb.Message.getFieldWithDefault(msg, 10, ""),
    bodyHtml: jspb.Message.getFieldWithDefault(msg, 11, ""),
    status: jspb.Message.getFieldWithDefault(msg, 12, ""),
    ownerEmail: jspb.Message.getFieldWithDefault(msg, 13, ""),
    topicDisplayName: jspb.Message.getFieldWithDefault(msg, 14, ""),
    isInbound: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    isOutbound: jspb.Message.getBooleanFieldWithDefault(msg, 16, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage}
 */
proto.qowner.erp.api.v1.model.EmailMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.qowner.erp.api.v1.model.EmailMessage;
  return proto.qowner.erp.api.v1.model.EmailMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.qowner.erp.api.v1.model.EmailMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage}
 */
proto.qowner.erp.api.v1.model.EmailMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setParentId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubject(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSender(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addRecipients(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addCopies(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setBodyText(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setBodyHtml(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerEmail(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setTopicDisplayName(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsInbound(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsOutbound(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.qowner.erp.api.v1.model.EmailMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.qowner.erp.api.v1.model.EmailMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.qowner.erp.api.v1.model.EmailMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getExternalId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getParentId();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getSubject();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSender();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRecipientsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getCopiesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getBodyText();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getBodyHtml();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getOwnerEmail();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getTopicDisplayName();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getIsInbound();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getIsOutbound();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 id = 2;
 * @return {number}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.getDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
*/
proto.qowner.erp.api.v1.model.EmailMessage.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.hasDate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string external_id = 4;
 * @return {string}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.getExternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.setExternalId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 parent_id = 5;
 * @return {number}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.getParentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.setParentId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string subject = 6;
 * @return {string}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.getSubject = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.setSubject = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string sender = 7;
 * @return {string}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.getSender = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.setSender = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated string recipients = 8;
 * @return {!Array<string>}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.getRecipientsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.setRecipientsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.addRecipients = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.clearRecipientsList = function() {
  return this.setRecipientsList([]);
};


/**
 * repeated string copies = 9;
 * @return {!Array<string>}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.getCopiesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.setCopiesList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.addCopies = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.clearCopiesList = function() {
  return this.setCopiesList([]);
};


/**
 * optional string body_text = 10;
 * @return {string}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.getBodyText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.setBodyText = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string body_html = 11;
 * @return {string}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.getBodyHtml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.setBodyHtml = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string status = 12;
 * @return {string}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string owner_email = 13;
 * @return {string}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.getOwnerEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.setOwnerEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string topic_display_name = 14;
 * @return {string}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.getTopicDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.setTopicDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional bool is_inbound = 15;
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.getIsInbound = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.setIsInbound = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional bool is_outbound = 16;
 * @return {boolean}
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.getIsOutbound = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.qowner.erp.api.v1.model.EmailMessage} returns this
 */
proto.qowner.erp.api.v1.model.EmailMessage.prototype.setIsOutbound = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


goog.object.extend(exports, proto.qowner.erp.api.v1.model);
